module.exports = __webpack_public_path__ + "static/media/logo.4adc84f7.webp";